import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";

const styles = {
  width: 300,
};

function FilterVessel({
  vesselPermit,
  vesselOptions = [],
  handleVesselChange,
}) {
  const filterOptions = createFilterOptions({
    matchFrom: "any",
    ignoreCase: true,
    trim: true,
    stringify: (option) =>
      option.PNUM + " " + option.HULL_ID + " " + option.VES_NAME,
  });

  return (
    <Autocomplete
      id="filterVessel"
      name="filterVessel"
      options={vesselOptions}
      getOptionLabel={(option) =>
        option.PNUM + " " + option.HULL_ID + " " + option.VES_NAME
      }
      style={styles}
      onChange={handleVesselChange}
      isOptionEqualToValue={(option) =>
        option.PNUM + " " + option.HULL_ID + " " + option.VES_NAME
      }
      clearOnEscape
      renderInput={(params) => (
        <TextField
          {...params}
          InputLabelProps={{ style: { fontSize: 16 } }}
          label="Vessel Permit"
          variant="standard"
          margin="normal"
        />
      )}
      filterOptions={filterOptions}
    />
  );
}

export default FilterVessel;
